import { render } from "./ChatDetailsRightItem.vue?vue&type=template&id=570daf77&scoped=true"
import script from "./ChatDetailsRightItem.vue?vue&type=script&lang=js"
export * from "./ChatDetailsRightItem.vue?vue&type=script&lang=js"

import "./ChatDetailsRightItem.vue?vue&type=style&index=0&id=570daf77&scoped=true&lang=css"

import exportComponent from "E:\\WebstormProjects\\sms-transfer-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570daf77"]])

export default __exports__